import React, { useEffect, useRef, useState } from "react";
import Select from "../../../components/form/select/Select";
import RichTextEditor from "../../form/RichTextEditor";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  addClauses,
  getUnderwritingData,
  resetUnderwriting,
} from "../../../redux/slice/underwriting/underwritingSlice";
import { useDispatch } from "react-redux";

const AddPreloadedClause = ({ modal_id, editData, setEditData }) => {
  const { underwritingData } = useSelector((state) => state?.underwriting);

  const [editing, setEditing] = useState(false);
  const [selectedClauseDescription, setSelectedClauseDescription] =
    useState(null);
  const [selectedClauseName, setSelectedClauseName] = useState(null);
  const [editedDescription, setEditedDescription] = useState(
    selectedClauseDescription
  );

  const close = useRef();
  const cancelRef = useRef();
  const pre_loaded_clauses_ref = useRef();
  const dispatch = useDispatch();

  const handleClose = () => {
    setSelectedClauseDescription("");
    pre_loaded_clauses_ref.current.clearValue();
    resetForm();
    editing && cancelRef.current.click();
    setEditData(null);
  };

  const onSubmit = (values) => {
    let payload = {
      ...values,
      clause_name: selectedClauseName,
      description: selectedClauseDescription,
    };
    dispatch(addClauses(payload));
    close.current.click();
  };

  const {
    values,
    touched,
    errors,
    handleBlur,
    handleChange,
    handleSubmit,
    resetForm,
    setFieldValue,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      clause_id: parseInt(editData?.clause_id) || "",
      clause_name: "",
    },
    validationSchema: yup.object({
      clause_id: yup.string().required("Clause name is required"),
    }),
    onSubmit,
  });

  // To select clause from the array of clauses from db
  useEffect(() => {
    if (values?.clause_id) {
      const selected = editData
        ? editData
        : underwritingData?.pre_loaded_clauses?.filter(
            (item) => item.id === values.clause_id
          )[0];
      setSelectedClauseDescription(selected?.description); //
      setSelectedClauseName(selected?.clause_name); //
    }
  }, [values?.clause_id]);

  useEffect(() => {
    setEditedDescription(selectedClauseDescription);
  }, [selectedClauseDescription]);

  return (
    <>
      <div
        className='modal fade'
        id={modal_id}
        data-bs-backdrop='static'
        data-bs-keyboard='false'
        tabIndex='-1'
        aria-labelledby='staticBackdropLabel'
        aria-hidden='true'
      >
        <div className='modal-dialog modal-dialog-scrollable' role='document'>
          <div className='modal-content rounded-4'>
            <div className='modal-header'>
              <h4 className='modal-title text-primary-1' id='myLargeModalLabel'>
                Add Preloaded Clause
              </h4>
              <span
                type='button'
                className=' bg-gray hover rounded-circle border-none'
                data-bs-dismiss='modal'
                aria-hidden='true'
                ref={close}
                onClick={() => {
                  handleClose();
                  //   setEditData(null);
                }}
                style={{ padding: "0px 3px" }}
              >
                <i
                  className='mdi mdi-close text-white'
                  style={{ fontSize: "16px" }}
                ></i>
              </span>
            </div>
            <div className='modal-body'>
              <form onSubmit={handleSubmit}>
                <div className='row mb-3'>
                  <div className='col-md-12 sm-text-end'>
                    <label htmlFor='username' className={`form-label mt-1`}>
                      Clause Name<span className='text-danger'>*</span>
                    </label>
                  </div>
                  <div className='col-md-12'>
                    <Select
                      onBlur={() => {
                        handleBlur({ target: { name: "cover_type" } });
                      }}
                      name='clause_id'
                      id='clause_id'
                      data={underwritingData?.pre_loaded_clauses?.map(
                        (item) => ({
                          label: item.clause_name,
                          value: item.id,
                        })
                      )}
                      disabled={editData}
                      value={values?.clause_id}
                      onChange={(selectedOption) => {
                        setFieldValue("clause_id", selectedOption?.value);
                      }}
                      ref={pre_loaded_clauses_ref}
                      isError={errors?.clause_id && touched?.clause_id}
                    />
                    {errors?.clause_id && touched?.clause_id && (
                      <p className='text-danger mb-0'>{errors?.clause_id}</p>
                    )}
                  </div>
                </div>
                {values.clause_id ? (
                  <>
                    <div className='row mb-4'>
                      <div className='col-md-12 sm-text-end'>
                        <label htmlFor='last_name' className='col-form-label'>
                          Description
                        </label>
                      </div>
                      <div className='col-sm-12'>
                        {!editing ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: selectedClauseDescription,
                            }}
                            className='border-0 shadow p-1 form-control'
                          />
                        ) : (
                          <div>
                            <RichTextEditor
                              name='description'
                              id='description'
                              value={editedDescription}
                              onChange={(value) => setEditedDescription(value)}
                            />
                            {errors?.description && touched?.description && (
                              <p
                                className='mb-0 text-danger'
                                style={{ marginTop: "40px" }}
                              >
                                {errors?.description + "*"}
                              </p>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='d-flex justify-content-end gap-3'>
                      <button
                        type='button'
                        ref={cancelRef}
                        className='btn btn-sm mt-2 px-3 text-white'
                        style={{ background: editing ? "#f1f1f1" : "#0E9CFF" }}
                        onClick={() => {
                          editing ? setEditing(false) : setEditing(true);
                        }}
                      >
                        {editing ? "Cancel" : "Edit"}
                      </button>
                      {editing ? (
                        <div>
                          <button
                            onClick={() => {
                              setSelectedClauseDescription(editedDescription);
                              setEditing(false);
                            }}
                            type='button'
                            className='btn btn-primary btn-sm mt-2 px-3 text-white'
                          >
                            Update
                          </button>
                        </div>
                      ) : (
                        <button
                          type='submit'
                          className='btn btn-primary btn-sm mt-2 px-3 text-white'
                        >
                          Add
                        </button>
                      )}
                    </div>
                  </>
                ) : null}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPreloadedClause;
